/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualLeasingContractDto } from '../../models/backend-actual-leasing-contract-dto';

export interface MonitoringActualsLeasingsCopyCreate$Params {
  id: number;
}

export function monitoringActualsLeasingsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsLeasingsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsLeasingsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualLeasingContractDto>;
    }),
  );
}

monitoringActualsLeasingsCopyCreate.PATH = '/api/monitoring/actuals/leasings/copy/{id}/';
